'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import I18n from 'I18n';
import { ColumnIcon, RowIcon, SectionIcon } from 'foundations-assets';
import PerformantDragLayer from 'layout-dnd-components/PerformantDragLayer';
import EPAddableTile from 'editor-components/sidebar/addableComponents/EPAddableTile';
import WidgetIcon from 'ContentComponents/cmv2/WidgetIcon';
import { getDragItemIsHidden } from 'InpageEditorUI/redux/selectors/layoutSectionDndSelectors';
import { isResizeHandleType } from 'InpageEditorUI/lib/layoutSection/resizeHandleHelpers';
import { DRAG_PREVIEW_HEIGHT_PX } from 'InpageEditorUI/lib/layoutSection/constants';
import { getAllModuleSchemas } from 'ContentEditorUI/redux/selectors/moduleSchemaSelectors';
import { getModules } from 'ContentEditorUI/redux/selectors/moduleSelectors';

// "customModules" acts as the default if we cannot find the iconUrl
import { jsx as _jsx } from "react/jsx-runtime";
const BAYMAX_TILE_SIZE = 36;
const HiddenDragPreview = styled.div.withConfig({
  displayName: "LayoutSectionCustomDragLayer__HiddenDragPreview",
  componentId: "sc-1ocl5ap-0"
})([".hs-private.hs-private.hs-private &{opacity:0.9;position:absolute;left:-18px;top:-12px;z-index:-1;}"]);
const getLayoutSectionIcon = ({
  dragParentId,
  isColumn,
  isRow,
  originLayoutSectionId
}) => {
  if (isColumn) {
    return ColumnIcon;
  } else if (isRow && dragParentId === originLayoutSectionId) {
    return SectionIcon;
  }
  return RowIcon;
};
const getLayoutSectionLabel = ({
  isColumn,
  isRow,
  dragParentId,
  originLayoutSectionId
}) => {
  if (isColumn) {
    return I18n.text('inpage.tile.column.label');
  }
  if (isRow && dragParentId === originLayoutSectionId) {
    return I18n.text('inpage.tile.section.label');
  }
  return I18n.text('inpage.tile.row.label');
};
class LayoutSectionCustomDragLayer extends Component {
  shouldRenderCustomDragIcon() {
    const {
      dragItemIsHidden,
      isDragging,
      item
    } = this.props;

    // If the item has a widgetCid, it is from the Inpage Sidebar Add Module panel.
    // In this scenario, we don't want to show the drag icon because those drags are using
    // the old-style Flex Column drag icons.
    // NOTE We will fix this soon to have those drags use the new-style Layout Section custom drag icons.
    return isDragging && item && item.originLayoutSectionId &&
    // Don't show drag icon for Flex Column module drags.
    !dragItemIsHidden && !item.widgetCid && !isResizeHandleType(item.type);
  }
  renderIcon(icon) {
    if (icon) {
      return /*#__PURE__*/_jsx(WidgetIcon, {
        size: BAYMAX_TILE_SIZE,
        color: "icon-core-subtle",
        icon: icon
      });
    }
    return null;
  }
  renderCustomDragIconForCleanLinesEditorUX() {
    const {
      item,
      modules,
      schemas
    } = this.props;
    const module = modules[item.dragId];
    const moduleId = module && module.get('module_id');
    const schema = moduleId && Object.values(schemas).find(_schema => _schema.moduleId === moduleId);
    const LayoutSectionIcon = getLayoutSectionIcon(item);
    if (schema && schema.icon) {
      return /*#__PURE__*/_jsx(HiddenDragPreview, {
        children: /*#__PURE__*/_jsx(EPAddableTile, {
          useOnDark: true,
          iconNode: this.renderIcon(schema.icon),
          text: schema.displayName
        })
      });
    }
    return /*#__PURE__*/_jsx(HiddenDragPreview, {
      children: /*#__PURE__*/_jsx(EPAddableTile, {
        useOnDark: true,
        iconNode: /*#__PURE__*/_jsx(LayoutSectionIcon, {
          size: "850",
          color: "icon-core-subtle"
        }),
        text: schema && schema.displayName || getLayoutSectionLabel(item)
      })
    });
  }
  render() {
    if (this.shouldRenderCustomDragIcon()) {
      return this.renderCustomDragIconForCleanLinesEditorUX();
    }
    return null;
  }
}
LayoutSectionCustomDragLayer.propTypes = {
  dragItemIsHidden: PropTypes.bool.isRequired,
  item: PropTypes.object,
  modules: PropTypes.array,
  schemas: PropTypes.array,
  isDragging: PropTypes.bool
};
LayoutSectionCustomDragLayer.propTypes = {
  isDragging: PropTypes.bool,
  item: PropTypes.object,
  schemas: PropTypes.object.isRequired,
  modules: PropTypes.object.isRequired
};
const performantDragLayerOptions = {
  zIndex: 2,
  dragPreviewHeightPx: DRAG_PREVIEW_HEIGHT_PX,
  dragPreviewWidthPx: DRAG_PREVIEW_HEIGHT_PX
};
const collect = monitor => ({
  isDragging: monitor.isDragging(),
  item: monitor.getItem(),
  itemType: monitor.getItemType()
});
const mapStateToProps = state => {
  return {
    dragItemIsHidden: getDragItemIsHidden(state),
    schemas: getAllModuleSchemas(state),
    modules: getModules(state)
  };
};
export default connect(mapStateToProps)(PerformantDragLayer(collect, performantDragLayerOptions)(LayoutSectionCustomDragLayer));